import { useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { ClassNames } from '@emotion/react';
import DiagramFrame, { DiagramGradients, stageWidthCap } from './vehicleDiagram/DiagramFrame';
import { buildVehicleGeometry } from './vehicleDiagram/layoutGeometry';
import { PLATE } from './vehicleDiagram/diagramTheme';

let instanceCount = 0;

const LayoutPreview = ({ layout }) => {
  const idRef = useRef(null);
  if (idRef.current === null) {
    instanceCount += 1;
    idRef.current = `tmp${instanceCount}`;
  }
  const uid = idRef.current;
  const geometry = useMemo(() => buildVehicleGeometry({ layout_template: layout }), [layout]);

  if (!geometry) {
    return <p className="tm-plate__fallback">No tyre positions in this layout.</p>;
  }

  const { tyres, width, height } = geometry;

  return (
    <ClassNames>
      {({ css }) => (
        <div className="tm-plate tm-plate--compact">
          <div className="tm-plate__stage">
            <svg viewBox={`0 0 ${width} ${height}`} className={`tm-plate__svg ${css({ maxWidth: stageWidthCap(geometry, 230) })}`} role="img" aria-label={`${layout?.name || 'Layout'} position map`}>
          <defs><DiagramGradients uid={uid} /></defs>
          <DiagramFrame geometry={geometry} uid={uid} />
          {tyres.map((tyre) => {
            const codeSize = Math.min(12, Math.max(8, tyre.width * 0.34));
            return (
              <g key={tyre.position.key || tyre.position.code} className="tm-tyre" data-empty transform={`translate(${tyre.x} ${tyre.y})`}>
                <rect className="tm-tyre__socket" x={-tyre.width / 2} y={-tyre.length / 2} width={tyre.width} height={tyre.length} rx={tyre.width * 0.34} />
                <text className="tm-tyre__code" y={codeSize * 0.35} fontSize={codeSize} fill={PLATE.steel}>{tyre.position.code}</text>
              </g>
            );
          })}
            </svg>
          </div>
        </div>
      )}
    </ClassNames>
  );
};

LayoutPreview.propTypes = { layout: PropTypes.object.isRequired };

export default LayoutPreview;
